module.exports = __webpack_public_path__ + "static/media/7.16e51b15.svg";